export default __webpack_public_path__ + "static/media/close-envelope.c6ee046e.svg";